import BackendResponse from '@core/shared/backend-response';
import { HttpGetRequest } from '@infrastructure/axios/http-get-request';
import { ContractCDRTotal, GetContractCDRTotalQuery, IGetContractCDRTotal } from '../../interfaces/contract-cdr-total';
import { validateQueryParams } from '../../validations/get-contract-cdr-totals';

export default class GetContractCDRTotal extends HttpGetRequest<ContractCDRTotal> implements IGetContractCDRTotal {
  public async execute(query: GetContractCDRTotalQuery): Promise<BackendResponse<ContractCDRTotal>> {
    const { id, duration } = validateQueryParams(query);
    const url = this.buildURL(`/contracts/${id}/cdr-total`, { duration }).get();
    return (await this.dispatch(url)).data;
  }
}
